import type { dynamicObj } from 'src/pages/assets';
import { setWithExpiry, getWithExpiry } from 'src/utils/cacheHelper';

export const Cache = {
  save(user_acls: dynamicObj) {
    setWithExpiry('acls', user_acls);
  },

  get() {
    const acls = getWithExpiry('acls') as dynamicObj;
    if (!acls) {
      return null;
    }

    return acls;
  },
};
